export default __webpack_public_path__ + "static/index_reason_eye-ba7e0187ade753dab304f1c0b966799b.png";